export default __webpack_public_path__ + "static/img-project-10-3644dd9d11ec295251b49f76706b635a.png";